/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState } from 'react';
import {
  TextareaWrapper,
  TextareaLabel,
  RequiredAsterisk,
  TextareaContainer,
  TextareaIcon,
  TextareaField,
  TextareaFooter,
  CharacterCount,
  WordCount,
  ErrorMessage,
} from './common-textarea-style';

const CommonTextarea = ({
  label,
  placeholder,
  value,
  onChange,
  icon,
  required = false,
  name,
  disabled = false,
  rows = 4,
  maxLength,
  maxWords,
  showCharCount = false,
  error,
  onBlur,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const countWords = (text) => {
    if (!text || text.trim() === '') return 0;
    return text.trim().split(/\s+/).filter((word) => word.length > 0).length;
  };

  const currentWordCount = countWords(value || '');
  const remainingWords = maxWords ? maxWords - currentWordCount : 0;

  const handleChange = (e) => {
    const newValue = e.target.value;

    if (maxWords) {
      const wordCount = countWords(newValue);
      if (wordCount > maxWords) {
        return;
      }
    }

    if (onChange) {
      onChange({
        ...e,
        target: {
          ...e.target,
          name,
          value: newValue,
        },
      });
    }
  };

  const handleBlur = (e) => {
    setIsFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <TextareaWrapper>
      {label && (
        <TextareaLabel>
          {label}
          {required && <RequiredAsterisk> *</RequiredAsterisk>}
        </TextareaLabel>
      )}
      <TextareaContainer
        isFocused={isFocused}
        isDisabled={disabled}
        hasError={!!error}
      >
        {icon && <TextareaIcon isDisabled={disabled}>{icon}</TextareaIcon>}
        <TextareaField
          placeholder={placeholder}
          value={value || ''}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          name={name}
          disabled={disabled}
          rows={rows}
          {...props}
        />
      </TextareaContainer>

      {error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : (
        (showCharCount || maxWords) && (
          <TextareaFooter>
            {maxWords && (
              <WordCount
                isNearLimit={remainingWords <= maxWords * 0.1}
                isAtLimit={remainingWords === 0}
              >
                {remainingWords === 0
                  ? 'Limite atingido'
                  : `${remainingWords} ${
                      remainingWords === 1 ? 'palavra restante' : 'palavras restantes'
                    }`}
              </WordCount>
            )}
            {showCharCount && maxLength && (
              <CharacterCount>
                {(value?.length || 0)}/{maxLength}
              </CharacterCount>
            )}
          </TextareaFooter>
        )
      )}
    </TextareaWrapper>
  );
};

export default CommonTextarea;
